import { lib } from '@giscube/geoportal'

import original from 'src/config'

function setup (conf) {
  // support to merge here and on the children's config
  let config = original
  if (conf) {
    if (conf instanceof lib.Options) {
      config = conf
    } else {
      config = original.merge(conf)
    }
  }

  return config
}

const configBoot = setup()
configBoot.setup = setup

export default configBoot
